module.exports = __webpack_public_path__ + "static/clip-3-b5df4c57a34ef01668b25944f0058302.jpg";